import React, { useState, useRef, useEffect } from 'react';
import { TextField, Button, Box, Card, CardContent, Grid, Typography, DialogTitle, Stack } from '@mui/material';
import SignatureCanvas from 'react-signature-canvas';
import DialogActions from '@mui/material/DialogActions';
import PhotoLibraryIcon from '@mui/icons-material/PhotoLibrary';
import { IconButton } from '@mui/material';
import TitleIcon from '@mui/icons-material/Title';
import DrawIcon from '@mui/icons-material/Draw';
import CustomDatePicker from '../commoncomponents/CustomDatePicker';
import CustomTextField from '../commoncomponents/CustomTextField';
import dayjs from 'dayjs';
import CustomSelectInput from '../commoncomponents/CustomSelectInput';
import axios from 'axios';
import { BemsGraph, FemsGraph, MasterGraph } from '../../utility/apiURLS';
import { getAuthToken,getcompanyId  } from '../../utility/tokenUtility';
import { useDispatch, useSelector } from 'react-redux';
import { Cancel } from '@mui/icons-material';
import { fetchData } from 'pdfjs-dist';
import PageLoader from '../commoncomponents/PageLoader';

const SignatureVerifyEnduser = ({ onCancel, onSave, rowData,onClose}) => {
    const currentDate = dayjs().format('DD/MM/YYYY');
    const basicDetails = useSelector((state) => state.workOrderBasicDetails);    
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const completionInfoData = basicDetails?.completionInfo || {};
    const categoryType = assetCategoryType?.category;
    const signaturePadRef = useRef({});
    const dispatch = useDispatch();
    const [pageLoading,setPageloading] = useState(false);
    const companyId = getcompanyId('companyId')
    // const workorderIds = Array.isArray(rowData) ? rowData.map(item => item.id) : [rowData?.id || ""];
    // const workorderIds = Array.isArray(rowData) ? rowData.map(item => item?.id, item?.maintenanceType, item?.service) : [rowData?.id || ""];
    const workorderIds = Array.isArray(rowData) 
    ? rowData.map(item => ({
        id: item?.id, 
        maintenanceType: item?.maintenanceType, 
        service: item?.service
    })) 
    : [{ 
        id: rowData?.id || "", 
        maintenanceType: rowData?.maintenanceType || "", 
        service: rowData?.service || "" 
    }];

    const [isenduser, setIsenduser] = useState(1);
    const [formData, setFormData] = useState({
        name: '',
        date: currentDate,
        contact: '',
        signature: '',
        fileSignature: null,
        mode: 'draw',
        designation: '',
        designationField: ''
    });

    let designationOptions;

    if (localStorage.getItem("roleName") === "DeptUser") {
        designationOptions = [
            { id: '2', label: 'End-User' }
        ];
    } else {
        designationOptions = [
            { id: '1', label: 'Vendor' },
            { id: '2', label: 'End-User' },
            { id: '3', label: 'Nominated Person' },
            { id: '4', label: 'FMS H.O.D' },
            { id: '5', label: 'Technician' },
            { id: '6', label: 'Others' }
        ];
    }

    const [error, setError] = useState({
        name: false,
        date: false,
        designationField: false,
        signupload: false,
        siganturePadValue:false
    });

    const [errorMessage, setErrorMessage] = useState({
        name: '',
        date: '',
        designationField: '',
        signupload: '',
        siganturePadValue:''
    });
    const [isButtonDisabled, setIsButtonDisabled] = useState(false);

    const updateErrorState = (hasError, errorMessage = '', name) => {
        setError(prevState => ({
            ...prevState,
            [name]: hasError
        }));
        setErrorMessage(prevState => ({
            ...prevState,
            [name]: errorMessage
        }));
    };

    const handleDateChange = (newDate) => {
        // Update the date in the form data state
        setFormData(prevState => ({
            ...prevState,
            date: newDate
        }));
    };

    const handleChange = (value, name,errorStateName) => {
        if (name === "name" || name === 'contact') {
            if (value?.startsWith(" ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not start with spaces`,
                }));
                return;
            } else if (value?.endsWith("  ")) {
                setError((prev) => ({
                    ...prev,
                    [name]: true,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: `${errorStateName} should not end with spaces`,
                }));
                return;
            } else {
                setError((prev) => ({
                    ...prev,
                    [name]: false,
                }));
                setErrorMessage((prev) => ({
                    ...prev,
                    [name]: "",
                }));
            }
        }

        if (name === 'contact') {
            const regex = /[^0-9+\-()/]/g;        
            value = value.replace(regex, ''); // Filter the value to allow only numbers, +, and -
        }

        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));

        if (error[name]) {
            setError(prevError => ({
                ...prevError,
                [name]: false
            }));
            setErrorMessage(prevError => ({
                ...prevError,
                [name]: ""
            }));
        }

        if (name === 'designationField') {
            setFormData(prevState => ({
                ...prevState,
                designation: value?.label
            }));
        }
    };


    const validateForm = () => {
        let formIsValid = true;
        const errorStatus = { ...error };
        const newErrorMessages = { ...errorMessage };

        if (!formData?.name || formData?.name?.trim() === '') {
            formIsValid = false;
            errorStatus.name = true;
            newErrorMessages.name = 'Name is required';
        }

        if (!formData?.date) {
            formIsValid = false;
            errorStatus.date = true;
            newErrorMessages.date = 'Date is required';
        }

        if (!formData?.designationField) {
            formIsValid = false;
            errorStatus.designationField = true;
            newErrorMessages.designationField = 'Designation is required';
        }

        if (formData?.mode === 'upload' && !formData?.fileSignature) {
            formIsValid = false;
            errorStatus.signupload = true;
            newErrorMessages.signupload = 'Please upload a signature';
        } else if (formData?.mode === 'draw' && !formData?.signature) {
            formIsValid = false;
            errorStatus.signupload = true;
            newErrorMessages.signupload = 'Please draw a signature';
        } else if (formData?.mode === 'text') {

            // Additional check for `siganturePadValue`
            if (!formData?.signature || formData?.signature.trim() === '' ) {
                // Case 1: Empty or spaces-only input
                formIsValid = false;
                errorStatus.signupload = true;
                errorStatus.siganturePadValue = false;
                newErrorMessages.signupload = 'Please enter a valid signature';
                newErrorMessages.siganturePadValue = '';
            } else if (formData?.signature !== formData?.signature.trim() || /(\s{2,})$/.test(formData?.signature)) {
                // Case 2: Ends with double or more spaces
                formIsValid = false;
                errorStatus.signupload = true;
                errorStatus.siganturePadValue = false;
                newErrorMessages.signupload = 'Signature Text should not end with spaces';
                newErrorMessages.siganturePadValue = '';
            } else {
                // Valid signature case
                errorStatus.signupload = false;
                errorStatus.siganturePadValue = false;
                newErrorMessages.signupload = '';
                newErrorMessages.siganturePadValue = '';
            }
        }

        setError(errorStatus);
        setErrorMessage(newErrorMessages);

        return formIsValid;
    };
    
    const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const intArray = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            intArray[i] = byteString.charCodeAt(i);
        }
        return new Blob([arrayBuffer], { type: mimeString });
    };

    const handleCancel = () => {
        setFormData({
            name: '',
            date: '',
            contact: '',
            signature: '',
            fileSignature: null,
            mode: 'draw'
        });
        onCancel(isenduser);
        
        
    };

    const handleFileUpload = (e) => {
        const file = e.target.files[0];
        if (file) {
            const fileType = file?.name?.split('.').pop().toLowerCase();
            const reader = new FileReader();
            reader.onload = (event) => {
                setFormData(prevState => ({
                    ...prevState,
                    fileSignature: event.target.result,
                    fileType: fileType,
                    fileSize: (file.size / 1024).toFixed(2) + ' KB'
                }));
            };
            reader.readAsDataURL(file);
            setError(prevState => ({
                ...prevState,
                signupload: false
            }));
            setErrorMessage(prevState => ({
                ...prevState,
                signupload: ''
            }));
        }
    };

    const handleModeChange = (newMode) => {
        setFormData(prevState => ({
            ...prevState,
            signature: '',
            fileSignature: '',
            fileType: '',
            fileSize: '',
            mode: newMode
        }));
        if (newMode === 'draw' && error?.signupload) {
            setErrorMessage(prevState => ({
                ...prevState,
                signupload: 'Please draw a signature'
            }))
        }
        if (newMode === 'upload' && error?.signupload) {
            setErrorMessage(prevState => ({
                ...prevState,
                signupload: 'Please upload a signature'
            }))
        }
        if (newMode === 'text' && error?.signupload) {
            setErrorMessage(prevState => ({
                ...prevState,
                signupload: 'Please enter a signature'
            }))
        }
    };


    const handleClear = () => {
        // Reset the signature field in the formData state
        setFormData(prevState => ({
            ...prevState,
            signature: '', // Clear the signature
            fileType: '', // Clear the file type
            fileSize: '', // Clear the file size
        }));

        // Clear the signature canvas if in draw mode
        if (formData.mode === 'draw') {
            signaturePadRef.current.clear();
        }

        // Clear the fileSignature if in upload mode
        if (formData.mode === 'upload') {
            setFormData(prevState => ({
                ...prevState,
                fileSignature: '',
                fileType: '', // Clear the file type
                fileSize: '', // Clear the file size
            }));
        }
    };


    function uuidv4(extension) {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        }) + '.' + extension;
    }

    const registerFiles = async (selectedFiles) => {
        const token = getAuthToken('id_token');
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        let storeFileNameArray = [];
        let storeregsitredFilesResponse = [];
        let storefileUploadResponse = [];
        for (let i = 0; i < selectedFiles?.length; i++) {
            const formData = new FormData();
            const extension = selectedFiles[i]?.documenttype;
            const fileName = uuidv4(extension); // generate a unique id
            formData.append('fileObj', selectedFiles[i]?.file, fileName); // append file with unique id as filename
            storeFileNameArray.push({ id: fileName, filename: `${selectedFiles[i]?.name}`, selectedFileId: selectedFiles[i]?.id });
            try {
                const fileUploadResponse = await axios.post(`${MasterGraph}/api/fileupload`, formData, config);
                storeregsitredFilesResponse.push(fileUploadResponse.data);
                storefileUploadResponse.push(fileUploadResponse.data);
            } catch (error) {
            //    console.log('Error uploading file:', error.response ? error.response.data : error.message);
            }
        }
        return { storefileUploadResponse, storeFileNameArray };
    };

    const changeDateFormat = (date) => {
        if (!date || !dayjs(date, 'DD/MM/YYYY').isValid() || date === 'Invalid Date' || date == null) {
            return '';
        }
        const convertedDate = dayjs(date, 'DD/MM/YYYY').format("YYYY-MM-DD");
        const finalDate = `${convertedDate}T00:00:00`;
        return finalDate;
    };

    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const checkGraph = assetCategoryType?.assetType === "fem" ? FemsGraph : BemsGraph;
    const categoryFieldName = categoryType === "Scheduled" ? "scheduled" : "unscheduled";
    const completionInfoCategoryType = categoryType === "Scheduled" ? "sch" : "unsch";

    const saveBulkFilesToSignature = async (payload, id,Sverify,Mverify) => {
     ;
        
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken('id_token')}`,
            },
        };
        const fileType = payload?.fileName?.split('.').pop();
        const commonPayload = {
            id: "",
            username: formData?.name,
            designation: formData?.designationField?.label,
            contactno: formData?.contact,
            signaturedate: changeDateFormat(formData?.date),
            filename: payload?.fileName,
            filesize: payload?.fileSize,
            documenttype: fileType,
            documenttitle: formData?.name,
        };
    

        // Iterate over workorderIDs and call the API for each ID
        for (const workorderId of workorderIds) {
       
            const checkFemorBem1 = workorderId?.service === "FEMS" ? "Fem" : "Bem";
            const serviceType1 = workorderId?.service === "FEMS" ? "fem" : "bem";
            const checkGraph1 = workorderId?.service === "FEMS" ? FemsGraph : BemsGraph;
            const categoryFieldName1 = workorderId?.maintenanceType === "Scheduled" ? "scheduled" : "unscheduled";
            const completionInfoCategoryType1 = workorderId?.maintenanceType === "Scheduled" ? "sch" : "unsch";
    
            const mergedPayload = { 
                ...commonPayload, 
                [`${checkFemorBem1}${categoryFieldName1}workorderheaderId`]: workorderId.id || basicDetails?.id || "", 
            }; //send completion info ID
           
            try {
                const response = await axios.post(
                    `${checkGraph1}/api/${serviceType1}${completionInfoCategoryType1}completionsignatures`,
                    mergedPayload,
                    config
                );
    
                
    
            } catch (error) {
                console.error('saveFilesToAttachment Save error:', error);
            }
        }
    };

    
    

    const updateverified = async () => {
        const config = {
            headers: {
                Authorization: `Bearer ${getAuthToken('id_token')}`
            }
        };
        setPageloading(true);
       
        // Ensure rowData is always an array
        const rowArray = Array.isArray(rowData) ? rowData : [rowData];
    
        if (rowArray.length === 0) {
            console.error("Error: rowData is empty after conversion to array.");
            return;
        }
    
        const requests = rowArray.map(item => {
            let endpoint;
    
            if (item?.service?.trim() === "FEMS") {
                endpoint = item?.maintenanceType?.trim() === "Unscheduled"
                    ? `${FemsGraph}/api/Graphfemworkorder/Updatefemunschworkorderverify/${item?.id}`
                    : `${FemsGraph}/api/Graphfemworkorder/Updatefemschworkorderverify/${item?.id}`;
            } else if (item?.service?.trim() === "BEMS") {
                endpoint = item?.maintenanceType?.trim() === "Unscheduled"
                    ? `${BemsGraph}/api/Graphbemworkorder/Updatebemunschworkorderverify/${item?.id}`
                    : `${BemsGraph}/api/Graphbemworkorder/Updatebemschworkorderverify/${item?.id}`;
            } else {
                console.warn(`Skipping item with unknown service: ${item?.service}`);
                return null;
            }
    
            return axios.put(endpoint, {}, config);
        }).filter(Boolean); // Removes `null` values if any item was skipped
    
        if (requests.length === 0) {
            console.warn("No valid requests to process.");
            return;
        }
    
        try {
            await Promise.all(requests);
            console.log("All records updated successfully");
            
            onClose();
            
        } catch (error) {
            console.error("Error updating records:", error);
        } finally
        {
            setPageloading(false);
        }
    };
    
    
    // const updateverified = async () => {
    //     const config = {
    //         headers: {
    //             Authorization: `Bearer ${getAuthToken('id_token')}`
    //         }
    //     };
    
    //     if (!Array.isArray(rowData) || rowData.length === 0) {
    //         console.error("rowData is not an array or is empty");
    //         return;
    //     }
    
    //     const requests = rowData.map(item => {
    //         let endpoint;
    
    //         if (item?.service === "FEMS") {
    //             endpoint = item?.maintenanceType === "Unscheduled"
    //                 ? `${FemsGraph}/api/Graphfemworkorder/Updatefemunschworkorderverify/${item?.id}`
    //                 : `${FemsGraph}/api/Graphfemworkorder/Updatefemschworkorderverify/${item?.id}`;
    //         } else {
    //             endpoint = item?.maintenanceType === "Unscheduled"
    //                 ? `${BemsGraph}/api/Graphbemworkorder/Updatebemunschworkorderverify/${item?.id}`
    //                 : `${BemsGraph}/api/Graphbemworkorder/Updatebemschworkorderverify/${item?.id}`;
    //         }
    
    //         return axios.put(endpoint, {}, config);
    //     });
    
    //     try {
    //         await Promise.all(requests);
    //         console.log("All records updated successfully");
    //     } catch (error) {
    //         console.error("Error updating records:", error);
    //     }
    // };
    


    const handleSave = async () => {
        const isValid = validateForm();
        if (isValid) {
            setIsButtonDisabled(true); // Disable the button on first click
            try {
                if (formData?.signature || formData?.fileSignature) {
                    let fileData;
                    let getFileType = formData?.fileType || '';
                    switch (formData.mode) {
                        case 'text':
                            const textBlob = new Blob([formData?.signature], { type: 'text/plain;charset=utf-8' })
                            fileData = new File([textBlob], 'signature.txt');
                            getFileType = 'txt';
                            break;
                        case 'draw':
                            fileData = dataURItoBlob(formData?.signature);
                            getFileType = 'png';
                            break;
                        case 'upload':
                            fileData = dataURItoBlob(formData?.fileSignature);
                            break;
                        default:
                            fileData = null;
                    }

                    const fileSize = fileData ? (fileData.size / 1024).toFixed(2) + ' KB' : '';

                    const data = {
                        documenttitle: formData.name,
                        date: formData.date,
                        contact: formData.contact,
                        designation: formData.designation,
                        documenttype: getFileType,
                        size: fileSize,
                        file: fileData,
                        date: formData.date,
                    };

                    const payload = [data];
                    const { storeFileNameArray, storefileUploadResponse } = await registerFiles(payload);
                    
                    const saveFilesToAttachment = await saveBulkFilesToSignature(storefileUploadResponse[0], basicDetails?.id || "", rowData.service,rowData.maintenanceType);
                    if(localStorage.getItem("roleName") === "DeptUser"){
                        await updateverified();
                    }
                    
                    dispatch({ type: "CREATE_COMPLETIONINFO", payload: { signatureFiles: saveFilesToAttachment } });

                    if (saveFilesToAttachment) {
                        onSave(data); // Call onSave with the data
                    }
                }
            } catch (error) {
                console.error('Error during save:', error);
            }
            // finally {
            //   setIsButtonDisabled(false); 
            // }
        } else {
          //  console.log('Form validation failed');
        }
       

    };

    const handlePhnNo = (value) => {
        const regex = /[^0-9+\-()]/g;
        return value.replace(regex, '');
    };

    const activeStyle = {
        backgroundColor: 'lightblue',
    };

    return (
        <>
        <PageLoader open={pageLoading} />
        <Card sx={{ boxShadow: 'none', height: 'auto' }}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant='title2' > Add Signature </Typography>
                <IconButton
                    variant="contained"
                    onClick={handleCancel}
                >
                    <Cancel />
                </IconButton>
            </Stack>
            <CardContent>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            label="Name"
                            id="name"
                            name="name"
                            variant="outlined"
                            isMandatoryField={true}
                            error={error?.name}
                            fullWidth
                            value={formData?.name}
                            onChange={(e)=>handleChange(e,"name","Name")}
                            errorMessage={errorMessage?.name}
                            autoFocus
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomTextField
                            label="Contact"
                            id="contact"
                            name="contact"
                            variant="outlined"
                            maxlength={20}
                            value={handlePhnNo(formData.contact)}
                            onChange={(e)=>handleChange(e,"contact","Contact")}
                        />
                    </Grid>

                    <Grid item xs={12} sm={6}>
                        <CustomDatePicker
                            label="Date"
                            id="date"
                            name="date"
                            value={formData?.date}
                            isMandatoryField={true}
                            error={error?.date}
                            errorMessage={errorMessage?.date}
                            onDateChange={handleDateChange}
                            modal={true}
                            maxDate={currentDate}
                        />

                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <CustomSelectInput
                            modal={true}
                            label="Designation"
                            id="designation"
                            name="designationField"
                            variant="outlined"
                            value={formData?.designationField}
                            isMandatoryField={true}
                            error={error?.designationField}
                            errorMessage={errorMessage?.designationField}
                            onChange={handleChange}
                            options={designationOptions}
                        />
                    </Grid>
                </Grid>
            </CardContent>

            <CardContent>
                <Grid container alignItems="center" spacing={1}>
                    {/* <Grid item>
                        <IconButton
                            variant="contained"
                            onClick={() => handleModeChange('text')}
                            style={{
                                marginRight: 10,
                                ...(formData.mode === 'text' && activeStyle),
                            }}
                            disabled={formData.mode === 'text' ? true : false}
                        >
                            <TitleIcon />
                        </IconButton>
                        <Typography
                            variant="body1"
                            align="center"
                            style={formData.mode === 'text' ? { color: 'black' } : {}}
                        >
                            Text
                        </Typography>
                    </Grid> */}

                    <Grid item>
                        <IconButton
                            variant="contained"
                            onClick={() => handleModeChange('draw')}
                            style={{
                                marginRight: 10,
                                ...(formData.mode === 'draw' && activeStyle),
                            }}
                            disabled={formData.mode === 'draw' ? true : false}
                        >
                            <DrawIcon />
                        </IconButton>
                        <Typography
                            variant="body1"
                            align="center"
                            style={formData.mode === 'draw' ? { color: 'black' } : {}}
                        >
                            Draw
                        </Typography>
                    </Grid>
                    {companyId === 'b4053d9f-ead7-49b5-bfee-649adae151e2' && (
                    <Grid item>
                        <IconButton
                            variant="contained"
                            onClick={() => handleModeChange('upload')}
                            style={{
                                marginRight: 10,
                                ...(formData.mode === 'upload' && activeStyle),
                            }}
                            disabled={formData.mode === 'upload' ? true : false}
                        >
                            <PhotoLibraryIcon />
                        </IconButton>
                        <Typography
                            variant="body1"
                            align="center"
                            style={formData.mode === 'upload' ? { color: 'black' } : {}}
                        >
                            Upload
                        </Typography>
                    </Grid>
                       )} 
                </Grid>

                <Box
                    border={1}
                    borderColor={error?.signupload ? "red" : "grey.400"}
                    p={2}
                    mb={2}
                    position="relative"
                >
                    {formData.mode === 'draw' && (
                        <SignatureCanvas
                            ref={signaturePadRef}
                            canvasProps={{
                                className: 'signatureCanvas',
                                style: { border: '1px solid black', width: '100%', height: '50%', borderRadius: '10px' },
                            }}
                            onEnd={() => {
                                const canvas = signaturePadRef.current.getCanvas();
                                const ctx = canvas.getContext('2d');

                                // Apply white background to the canvas
                                ctx.globalCompositeOperation = 'destination-over';
                                ctx.fillStyle = 'white';
                                ctx.fillRect(0, 0, canvas.width, canvas.height);

                                ctx.globalCompositeOperation = 'source-over';
                                // Save the signature with the white background as dataURL
                                const signatureDataUrl = canvas.toDataURL();

                                setFormData((prevState) => ({
                                    ...prevState,
                                    signature: signatureDataUrl,  // Store the signature with the white background
                                }));
                                setError(prevState => ({
                                    ...prevState,
                                    signupload: false
                                }));
                                updateErrorState(false, '', 'signupload');
                            }}
                        />
                    )}

                    {formData.mode === 'upload' && formData.fileSignature && (
                        <img
                            src={formData.fileSignature}
                            alt="Uploaded Signature"
                            style={{ maxWidth: '100%', marginTop: 10 }}
                        />
                    )}

                    {formData.mode === 'text' && (
                        <TextField
                            fullWidth
                            multiline
                            rows={5}
                            variant="outlined"
                            value={formData.signature}
                            onChange={(e) => {
                                const value = e?.target?.value

                                if (value?.startsWith(" ")) {
                                    setError((prev) => ({
                                        ...prev,
                                        siganturePadValue: true,
                                    }));
                                    setErrorMessage((prev) => ({
                                        ...prev,
                                        siganturePadValue: `Signature Text should not start with spaces`,
                                    }));
                                    return;
                                } else if (value?.endsWith("  ")) {
                                    setError((prev) => ({
                                        ...prev,
                                        siganturePadValue: true,
                                    }));
                                    setErrorMessage((prev) => ({
                                        ...prev,
                                        siganturePadValue: `Signature Text should not end with spaces`,
                                    }));
                                    return;
                                } else {
                                    setError((prev) => ({
                                        ...prev,
                                        siganturePadValue: false,
                                    }));
                                    setErrorMessage((prev) => ({
                                        ...prev,
                                        siganturePadValue: "",
                                    }));
                                }

                                setFormData((prevState) => ({
                                    ...prevState,
                                    signature: value,
                                }));
                                if (value) {
                                    updateErrorState(false, '', 'signupload');
                                }
                            }
                            }
                            error={error?.siganturePadValue}
                            helperText={errorMessage?.siganturePadValue || ""}
                        />
                    )}

                    {formData.mode === 'upload' && (
                        <>
                            {formData.fileType ? (
                                <Button variant="contained">UPLOADED FILE</Button>
                            ) : (
                                <Button variant="outlined" component="label">
                                    UPLOAD FILE
                                    <input
                                        type="file"
                                        accept="image/*"
                                        hidden
                                        onChange={handleFileUpload}
                                    />
                                </Button>
                            )}
                        </>
                    )}
                </Box>
                {error?.signupload && (
                    <Typography component={"span"} color={"error"}>
                        {errorMessage?.signupload}
                    </Typography>
                )}

            </CardContent>
            <DialogActions>
                <Button onClick={handleCancel} color="primary" variant='outlined'>Cancel</Button>
                <Grid container justifyContent="flex-end" alignItems="center" spacing={2}>
                    <Button onClick={handleClear} color="primary" variant="contained" autoFocus>{formData.mode !== 'upload' ? "Clear" : "Remove"}</Button> &nbsp;&nbsp;
                    <Button onClick={handleSave} color="primary" variant="contained" autoFocus disabled={isButtonDisabled}>Add Signature</Button>
                </Grid>
            </DialogActions>
        </Card>
        </>
    );
};

export default SignatureVerifyEnduser;
